angular.module('impactx.lobby').controller('LobbyCtrl', LobbyCtrl);
LobbyCtrl.$inject = [
    '$scope',
    'dataGen',
    'searchFilter',
    '$redirect',
    '$context',
    '$securityManager',
    'SearchFilter',
    'AppConfiguration',
    'ThemeWorldService',
    'ToastService',
    '$workspaceIdHolder',
    'TranslationService'
];

function LobbyCtrl($scope, dataGen, searchFilter, $redirect, $context, $securityManager, SearchFilter, AppConfiguration, ThemeWorldService, ToastService, $workspaceIdHolder, TranslationService) {

    var self = this;
    var getData = function() {
        dataGen.postAsForm($scope, {getData: true}, "/lobby");
    };

    if (AppConfiguration.get('leaveThemeWorldOnStartPage') && $context.hasActiveThemeWorldSearch && $context.hasActiveThemeWorldSearch.value) {
        ThemeWorldService.deactivateActiveThemeWorldSearch(true).then(function (data) {
            self.refreshSearchInfo(data);
        });
    }
    else {
        getData();
    }

    this.refreshSearchInfo = function(themeWorldData) {
        dataGen.getData({}, {}, "/search/info").then(function(data) {
            data = data.data;
            if(data !== null && data !== undefined) {
                $context.hasActiveThemeWorldSearch.theme = data.themeWorldTheme;
                $context.hasActiveThemeWorldSearch.value = data.hasActiveThemeWorldSearch;
                $context.hasActiveThemeWorldSearch.id = data.themeWorldSearchId;
                $workspaceIdHolder.themeWorldTheme.value = data.themeWorldTheme;
                TranslationService.add("searchPlaceHolder", data.searchPlaceHolder);
                searchFilter.resetSearchFilter().then(function() {
                    ToastService.openStandardToast(themeWorldData.trns.themeWorldDeactivated);
                    getData();
                });
            }

        });
    };


    $scope.search = function() {
        $redirect.redirectTo(null, "search.all")
    };

    $scope.searchProductFamily = function(selected) {
        SearchFilter.setProductFamily(selected);
        $redirect.redirectTo(null, "/search");
    };

    $scope.searchProcurementGroup = function(selected, productFamily) {
        SearchFilter.setProductFamily(productFamily);
        SearchFilter.setProcurementGroup(selected);
        $redirect.redirectTo(null, "/search");
    };

    $scope.$watch(function() {
        return $context.showSearch.value
    }, function(newVal, oldValue) {
        if(newVal && !oldValue) {
            searchFilter.resetSearchFilter().then(function() {
                searchFilter.searchInput = '';
                searchFilter.searchInputGlobal = '';
                $scope.fixedFilters = searchFilter.getSearchFilterData();
                SearchFilter.resetSearchInput();
            });
        }
    });

    $scope.$watch(function() {
        return $context.hasSupplierBasket.value
    }, function(newValue, oldValue) {
        if(!angular.equals(newValue, oldValue)) {
            //refresh lobby data, by supplier basket deactivation
            dataGen.postAsForm($scope, {getData: true}, "/lobby");
        }
    });

    $securityManager.isProcessAllowedWatch($scope, "Search", function(isAllowed) {
        if(isAllowed) {
            searchFilter.resetSearchFilter().then(function() {
                searchFilter.searchInput = '';
                searchFilter.searchInputGlobal = '';
                $scope.fixedFilters = searchFilter.getSearchFilterData();
                SearchFilter.resetSearchInput();
            });
        }
    });
}

